<template>
  <nav :class="{ active: menuActive }">
    <ul v-if="menuActive">
      <li>
        <router-link to="/o-mnie"> o mnie </router-link>
      </li>
      <li class="offer">
        <template v-if="isMobile">
          <span
            @click="toggleOfferDropdown"
            class="offer-toggle"
            role="button"
            :aria-expanded="offerDropdownActive"
            aria-controls="offer-dropdown"
          >
            &#9662; oferta
          </span>
        </template>
        <template v-else>
          <router-link to="/oferta">&#9662; oferta </router-link>
        </template>
        <ul class="dropdown" id="offer-dropdown" v-show="!isMobile || offerDropdownActive">
          <li><router-link to="/oferta"> Oferta </router-link></li>
          <li v-for="offer in offers" :key="offer.uid">
            <router-link :to="{ name: 'single-offer', params: { slug: offer.uid } }">
              {{ getOfferTitle(offer) }}
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link to="/wnetrza-prywatne"> wnętrza prywatne </router-link>
      </li>
      <li>
        <router-link to="/wnetrza-publiczne"> wnętrza publiczne </router-link>
      </li>
      <li>
        <router-link to="/publikacje-i-nagrody"> publikacje i nagrody </router-link>
      </li>
      <li>
        <router-link to="/kontakt"> kontakt </router-link>
      </li>
      <li class="social-media social-media--desktop">
        <a
          href="https://www.facebook.com/wnetrzasergiej/"
          rel="noopener"
          target="_blank"
          aria-label="Facebook"
        >
          <img src="@/assets/facebook.svg" alt="Facebook" />
        </a>
        <a
          href="https://www.instagram.com/msergiejwnetrza/"
          rel="noopener"
          target="_blank"
          aria-label="Instagram"
        >
          <img src="@/assets/instagram.svg" alt="Instagram" />
        </a>
      </li>
    </ul>
    <div v-if="!menuActive" class="mobile-header">
      <a v-on:click="toggleMenu()" class="btn-burger">
        <div></div>
        <div></div>
        <div></div>
      </a>
      <div class="social-media social-media--mobile">
        <a
          href="https://www.facebook.com/wnetrzasergiej/"
          rel="noopener"
          target="_blank"
          aria-label="Facebook"
        >
          <img src="@/assets/facebook.svg" alt="Facebook" />
        </a>
        <a
          href="https://www.instagram.com/msergiejwnetrza/"
          rel="noopener"
          target="_blank"
          aria-label="Instagram"
        >
          <img src="@/assets/instagram.svg" alt="Instagram" />
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
  import { asText } from '@prismicio/helpers';

  export default {
    name: 'Navigation',
    data() {
      return {
        menuActive: true,
        offerDropdownActive: false,
        offers: [],
      };
    },
    watch: {
      $route() {
        if (document.documentElement.clientWidth < 768) {
          document.body.classList.remove('disabledScroll');
          this.menuActive = false;
          this.offerDropdownActive = false;
        }
      },
    },
    computed: {
      isMobile() {
        return document.documentElement.clientWidth < 768;
      },
    },
    methods: {
      toggleMenu() {
        this.menuActive = !this.menuActive;

        this.menuActive
          ? document.body.classList.add('disabledScroll')
          : document.body.classList.remove('disabledScroll');
      },
      toggleOfferDropdown() {
        this.offerDropdownActive = !this.offerDropdownActive;
      },
      getWindowWidth() {
        if (document.documentElement.clientWidth > 768) {
          this.menuActive = true;
          this.offerDropdownActive = false;
        } else {
          this.menuActive = false;
        }
      },
      getOffers() {
        this.$prismic.client
          .query(this.$prismic.Predicates.at('document.type', 'oferta'), {
            orderings: '[my.oferta.date desc]',
          })
          .then((response) => {
            this.offers = response.results;
          });
      },
      getOfferTitle(offer) {
        return asText(offer.data.title);
      },
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.getWindowWidth);
        this.getWindowWidth();
        this.getOffers();
      });
    },
  };
</script>

<style scoped lang="scss">
  @use '../AppVariables' as *;
  nav {
    display: flex;
    align-items: center;
    justify-content: center;

    border-bottom: 1px solid $bgColor;
    font-size: 1em;
    transition-duration: $duration * 4;

    .btn-burger {
      &:hover {
        div {
          transition-duration: $duration;
          &:last-of-type {
            width: 20px;
          }
        }
      }

      div {
        width: 20px;
        height: 2px;
        margin-bottom: 4px;
        background-color: $fontColor;
        transition-duration: $duration;

        &:last-of-type {
          width: 15px;
          margin-bottom: 0;
        }
      }
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: inline-block;
        margin: 0;
        padding: 0 15px;
        color: $fontColor;

        /**
         * Important for dropdown positioning
         */
        position: relative;

        a {
          color: inherit;
          text-decoration: none;

          &:hover,
          &.router-link-active {
            opacity: 0.5;
          }

          &.active {
            color: inherit;
          }
        }
      }
    }

    .offer {
      .offer-toggle {
        cursor: pointer;
        user-select: none;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }
      }

      .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        background-color: $bgColor;
        list-style: none;
        padding: 10px 0;
        min-width: 150px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        display: none;
        z-index: 100;

        li {
          display: block;
          padding: 5px 15px;
          white-space: nowrap;

          a {
            color: $fontColor;
            &:hover,
            &.router-link-active {
              opacity: 0.8;
            }
          }
        }
      }

      &:hover {
        .dropdown {
          display: block;
        }
      }
    }

    .social-media {
      a {
        display: inline-block;
        margin: 0 5px;

        img {
          width: 18px;
          height: 18px;
          vertical-align: middle;
        }

        &:hover {
          opacity: 0.5;
        }
      }
    }

    .mobile-header {
      display: none;
    }

    @media (max-width: 768px) {
      /** MOBILE */
      height: 50px;
      font-size: 1.4em;
      flex-wrap: wrap;
      flex-basis: 100%;
      overflow: auto;

      &.active {
        height: calc(100vh - 130px);
        align-items: flex-start;
        padding-top: 20px;
      }

      ul {
        li {
          display: block;
          padding: 5px;
          text-align: center;
        }
      }

      .offer {
        .dropdown {
          display: block;
          position: static;
          box-shadow: none;
        }
      }

      .social-media--desktop {
        display: none;
      }

      .mobile-header {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        position: relative;
      }

      .btn-burger {
        padding: 10px;
      }

      .social-media--mobile {
        position: absolute;
        right: 15px;
        display: flex;
        align-items: center;
        gap: 4px;

        a {
          display: inline-block;
          padding: 10px;

          img {
            width: 20px;
            height: 20px;
            display: block;
          }

          &:hover {
            opacity: 0.5;
          }
        }
      }
    }

    @media (min-width: 768px) {
      height: 80px;
      font-size: 0.9em;
    }

    @media (min-width: 1940px) {
      height: 100px;
      font-size: 1em;
    }
  }
</style>
